import { PhoneUtils } from '@pbt/pbt-ui-components'

import type {
  DeliveryMethod,
  SendToRecipient,
} from '../constants/paymentRequestDialogV2Constants'

export function formatSendToDisplay(
  sendTo: SendToRecipient[],
  deliveryMethod: DeliveryMethod,
): string {
  return sendTo
    .map((r) => {
      const contact =
        deliveryMethod === 'email'
          ? r.email
          : r.phone
            ? PhoneUtils.formatPhoneNumber(r.phone)
            : null
      return contact ? `${r.name} (${contact})` : r.name
    })
    .join(', ')
}
